import React from 'react'
import { useFormContext } from 'react-hook-form'
import CaluButton from '@/components/styledComponents/CaluButton'
import { getUserByEmail } from '@/services/users'
import { showToast } from '@/utils/toast'
import { Grid } from '@mui/material'

import s from './styles.module.scss'

const FormStepperButtons = ({ step, setStep, stepText, saveValues, isLastStep, isLoading }) => {
  const { trigger, getValues } = useFormContext()
  const checkIfEmailExists = async () => {
    const currentValues = getValues()
    const userEmail = currentValues?.email
    const existingEmail = await getUserByEmail(userEmail)
    return existingEmail?.exists
  }
  const handleNextStep = async () => {
    const currentValues = getValues()

    let fieldsToValidate = []

    if (step === 0) {
      fieldsToValidate = ['email', 'password', 'repeatPassword']
    } else if (step === 1) {
      fieldsToValidate = ['firstname', 'lastname', 'mobiles', 'category', 'centreName']
    }

    const isValid = await trigger(fieldsToValidate)

    if (!isValid) return

    if (step === 0) {
      const isEmailTaken = await checkIfEmailExists()
      if (isEmailTaken) {
        showToast('El email ya existe, intente con otro.', 'error')
        return
      }
    }

    saveValues(currentValues)
    setStep((prev) => prev + 1)
  }

  const handleBackStep = () => {
    setStep((prev) => prev - 1)
  }

  return (
    <Grid container className={s.buttonsContainer}>
      {!isLastStep && step === 0 ? (
        <CaluButton type="button" color="primary" onClick={() => handleNextStep(step)}>
          {stepText.buttonText}
        </CaluButton>
      ) : (
        <CaluButton type="submit" color="primary" loading={isLoading}>
          {stepText.buttonText}
        </CaluButton>
      )}
      {step > 0 && (
        <CaluButton color="primary" type="button" inverted={true} onClick={handleBackStep}>
          Regresar
        </CaluButton>
      )}
    </Grid>
  )
}
export default FormStepperButtons
